import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { register } from 'swiper/element/bundle';
// register Swiper custom elements
register();
import '@angular/localize/init';
import 'intersection-observer';
import { environment } from '@env/environment';

function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
  return null;
}
let cookies = getCookie('__CLMM');

if(cookies) {
  environment.CLMM_NAME=cookies;
  environment.ISCLMM=true;
}else{
}
// CleverTap functionality disabled

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
